import endpoints, { axios } from "../../config/api";

async function getCommercialFolderProject(projectId: number) {
  return await (
    await axios.get(endpoints.project.getCommercialFolder(projectId), {
      maxRedirects: 1
    })
  ).data;
}

export default getCommercialFolderProject;
